module.exports = __webpack_public_path__ + "img/15days.e144da5c.svg";